import React from 'react';
import { AwesomeButton } from 'react-awesome-button';
import Tooltip from './Tooltip';
import '../../shared/styles/Button.css';

import trialment from '../../shared/assets/button-icons/trialment.png';
import cota from '../../shared/assets/button-icons/cota.png';
import orchestrator from '../../shared/assets/button-icons/orchestrator.png';
import d4 from '../../shared/assets/button-icons/d4.png';
import d6 from '../../shared/assets/button-icons/d6.png';
import d8 from '../../shared/assets/button-icons/d8.png';
import d10 from '../../shared/assets/button-icons/d10.png';
import d12 from '../../shared/assets/button-icons/d12.png';
import d20 from '../../shared/assets/button-icons/d20.png';
import duality from '../../shared/assets/button-icons/duality.png';
import show from '../../shared/assets/button-icons/show.png';
import hide from '../../shared/assets/button-icons/hide.png';
import death from '../../shared/assets/button-icons/death.png';
import removeDeath from '../../shared/assets/button-icons/death2.png';
import daggerheart from '../../shared/assets/button-icons/daggerheart.png';
import dnd from '../../shared/assets/button-icons/dnd.png';
import pathfinder from '../../shared/assets/button-icons/pathfinder.png';
import pathfinder2 from '../../shared/assets/button-icons/pathfinder2.png';
import starfinder from '../../shared/assets/button-icons/starfinder.png';
import starfinder2 from '../../shared/assets/button-icons/starfinder2.png';
// Additional icons now come from lucide-react; only these png assets remain bundled locally.

/*
Supported Button `type` themes (customized in Button.css):
black | black-white | blue | cinnabar | disabled | duality-blessed |
duality-doomed | epic-gold | gplus | green | github | ivory | onyx |
pathfinder | pathfinder2 | pinterest | placeholder | starfinder |
starfinder2 | tomato | youtube

When omitted, the type defaults to `tomato`. `loading` overrides it with
`placeholder`, and `disabled` overrides it with `disabled`.
*/

/* Registered PNG icon keys (pass as the `icon` prop):
trialment | cota | orchestrator | d4 | d6 | d8 | d10 | d12 | d20 | duality |
show | hide | death | removeDeath | daggerheart | dnd | pathfinder |
pathfinder2 | starfinder | starfinder2
*/

const ICONS = {
  trialment,
  cota,
  orchestrator,
  d4,
  d6,
  d8,
  d10,
  d12,
  d20,
  duality,
  death,
  removeDeath,
  show,
  hide,
  daggerheart,
  dnd,
  pathfinder,
  pathfinder2,
  starfinder,
  starfinder2,
};

export const BUTTON_ICONS = ICONS;

/*
 * lucide-react icon library is available.
 * Pass any Lucide icon component as the `icon` prop to render it inside the button.
 * Example:
 *   import { Swords } from 'lucide-react';
 *   <Button icon={Swords} label="Attack" type="cinnabar" />
 */

//TODO replaceOnClickProp because of Span

export const Button = (props) => {
  const { loading, onPress, type, disabled, label, icon, description, ariaLabel, descriptionUp = false, condensed = true } = props;

  const showTooltip = !!description;
  const computedAriaLabel = ariaLabel || label || description || undefined;
  const buttonType = loading ? 'placeholder' : disabled ? 'disabled' : type || 'tomato';

  const doPress = () => {
    if (!disabled && type !== 'disabled' && typeof onPress === 'function') {
      onPress();
    }
  };

  // Lucide icons are `forwardRef` components (objects), not plain functions – treat any non-string as a React icon
  const isLibraryIcon = icon && typeof icon !== 'string';
  const isPngIcon = icon && typeof icon === 'string';
  const iconSrc = isPngIcon ? ICONS[icon] : undefined;

  const renderLibraryIcon = () => {
    if (!isLibraryIcon) return null;

    return React.createElement(icon, {
      size: 20,
      strokeWidth: 2.5,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      className: 'df_btn_library_icon',
      style: { marginLeft: !label ? '6.23px' : '0', flexShrink: 0 }, //6.23px here
    });
  };

  const ICON_STYLE = { height: 20, width: 20, marginLeft: !label ? '6.23px' : '0', marginRight: !label ? '2.23px' : '0', flexShrink: 0 };

  return (
    <Tooltip content={showTooltip ? description : null} placement={descriptionUp ? 'top' : 'bottom'}>
      <span
        className='df_button_wrapper'
        aria-label={computedAriaLabel}
        onClick={() => {
          !disabled && doPress();
        }}
      >
        <AwesomeButton
          type={buttonType}
          aria-label={computedAriaLabel}
          className={condensed && !label ? 'df_btn_condensed' : undefined}
        >
          {isLibraryIcon && (
            <>
              {/* Lucide-react icon component */}
              {renderLibraryIcon()}
              &nbsp;
            </>
          )}
          {iconSrc && (
            <>
              <img
                className='system_logo_txt'
                src={iconSrc}
                alt=''
                style={ICON_STYLE}
              />
              &nbsp;
            </>
          )}
          {label}
        </AwesomeButton>
      </span>
    </Tooltip>
  );
};
